var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6891 4.86738L0.128784 1.20066C-0.0429278 1.02382 -0.0429278 0.737113 0.128784 0.560289L0.544038 0.132627C0.715456 -0.0439134 0.993276 -0.0442529 1.1651 0.131872L4.00001 3.03781L6.8349 0.131872C7.00672 -0.0442527 7.28454 -0.0439131 7.45596 0.132627L7.87122 0.56029C8.04293 0.737132 8.04293 1.02384 7.87122 1.20066L4.3109 4.86737C4.1392 5.04421 3.86082 5.04421 3.6891 4.86738Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/angle-down.9e7bcc2085af6b1bfe4dc61aecb46f00.svg";
export { ForwardRef as ReactComponent };